/* eslint-disable import/no-duplicates */
import { Row, Col, Container, Accordion } from 'react-bootstrap';
import CheckoutLayout from '../checkoutLayout/CheckoutLayout';
import {
  HeadingDescSmall,
  SectionHeadingMed
} from '../../../Components/Headings';
import { SimpleAncerSmall } from '../../../Components/button';
import checkIcon from '../../../assets/images/svg/check-green.svg';
import masterCardIcon from '../../../assets/images/png/master-card.png';
import visaCardIcon from '../../../assets/images/png/visa-card.png';
import easypaisaIcon from '../../../assets/images/png/easy-paisa.png';
import cashIcon from '../../../assets/images/png/cash.png';
import bankIcon from '../../../assets/images/png/bank.png';
import whatsapp from '../../../assets/images/png/whatsapp.png';
import './selectpaymentMethod.css';

function SelectpaymentMethod() {
  return (
    <section className="selectpaymentMethod">
      <CheckoutLayout>
        <Container>
          <Row>
            <Col md={8}>
              <SectionHeadingMed text="Select Payment Method" />
              <form className="form">
                <div className="paymentContainer">
                  <div className="paymentBox">
                    <div>
                      <div className="custom__radio check">
                        <input
                          type="radio"
                          name="custom"
                          id="credit-debit-card"
                          defaultChecked
                        />
                        <label htmlFor="credit-debit-card">
                          <img src={checkIcon} alt="checkIcon" />
                        </label>
                      </div>
                      Credit/Debit Card
                    </div>
                    <div className="imgBox cards">
                      <img src={masterCardIcon} alt="masterCardIcon" />
                      <img src={visaCardIcon} alt="visaCardIcon" />
                    </div>
                  </div>
                  <div className="paymentBox">
                    <div>
                      <div className="custom__radio check">
                        <input type="radio" name="custom" id="easypaisa" />
                        <label htmlFor="easypaisa">
                          <img src={checkIcon} alt="checkIcon" />
                        </label>
                      </div>
                      EasyPaisa Mobile Wallet
                    </div>
                    <div className="imgBox">
                      <img src={easypaisaIcon} alt="easypaisaIcon" />
                    </div>
                  </div>
                  <div className="paymentBox">
                    <div>
                      <div className="custom__radio check">
                        <input type="radio" name="custom" id="cash" />
                        <label htmlFor="cash">
                          <img src={checkIcon} alt="checkIcon" />
                        </label>
                      </div>
                      Pay Cash in Clinic
                    </div>
                    <div className="imgBox">
                      <img src={cashIcon} alt="cashIcon" />
                    </div>
                  </div>
                  <div className="paymentAccordion">
                    <Accordion>
                      <Accordion.Item eventKey="0">
                        <Accordion.Header>
                          <div className="custom__radio check">
                            <input type="radio" name="custom" id="bank" />
                            <label htmlFor="bank">
                              <img src={checkIcon} alt="checkIcon" />
                            </label>
                          </div>
                          Bank Transfer
                          <div>
                            <img
                              src={bankIcon}
                              alt="checkIcon"
                              className="bankIcon"
                            />
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          <ul className="noteForUser">
                            <li>
                              <HeadingDescSmall text="1. Transfer Rs. 1,800 to the Habib bank account mentioned below" />
                            </li>
                            <li>
                              <HeadingDescSmall text="2. Take a screenshot of the completed transaction" />
                            </li>
                            <li>
                              <HeadingDescSmall text="3. WhatsApp the screenshot to: 03000647873" />
                            </li>
                          </ul>
                          <ul className="bankInfo">
                            <li>
                              <HeadingDescSmall text="Account number" />
                              <HeadingDescSmall text="0607901038503 (branch code:1060)" />
                            </li>
                            <li>
                              <HeadingDescSmall text="Account title" />
                              <HeadingDescSmall text="Meri Sehat" />
                            </li>
                            <li>
                              <HeadingDescSmall text="Bank" />
                              <HeadingDescSmall text="Habib Bank Ltd" />
                            </li>
                            <li>
                              <HeadingDescSmall text="Branch" />
                              <HeadingDescSmall text="Garden Town" />
                            </li>
                            <li>
                              <HeadingDescSmall text="IBAN" />
                              <HeadingDescSmall text="PK68 HABB 0010607901038503" />
                            </li>
                          </ul>
                          <div className="btnBox">
                            <SimpleAncerSmall text="SEND THE TRANSACTION SCREENSHOT TO +92 334 341 1234">
                              <img src={whatsapp} alt="whatsapp" />
                            </SimpleAncerSmall>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </div>
                </div>
              </form>
            </Col>
            <Col md={5}>
              <div className="btnBlack">
                <SimpleAncerSmall to="/paymentConfimation" text="Pay Now" />
              </div>
            </Col>
          </Row>
        </Container>
      </CheckoutLayout>
    </section>
  );
}
export default SelectpaymentMethod;
